import { Action, createReducer, on } from '@ngrx/store';
import { IEMData, IPaymentInfo } from '@dch/billing-business-logic';
import {
  getBillingPaymentInfoFailure,
  getBillingPaymentInfoRequest,
  getBillingPaymentInfoSuccess,
} from '../actions/billing-payment-info.actions';

export interface BillingPaymentInfoState {
  byAccountNumber: { [accountNumber: string]: IEMData<IPaymentInfo> };
}

export const initialState: BillingPaymentInfoState = {
  byAccountNumber: {},
};

export const billingPaymentInfoReducer = createReducer(
  initialState,
  on(getBillingPaymentInfoRequest, (state, { billingAccountNumber }) => ({
    ...state,
    byAccountNumber: {
      ...state.byAccountNumber,
      [billingAccountNumber]: {
        result: state.byAccountNumber[billingAccountNumber]?.result ?? null,
        hasError: false,
        isFetching: true,
      },
    },
  })),
  on(
    getBillingPaymentInfoSuccess,
    (state, { billingAccountNumber, paymentInfo }) => ({
      ...state,
      byAccountNumber: {
        ...state.byAccountNumber,
        [billingAccountNumber]: {
          result: paymentInfo,
          hasError: false,
          isFetching: false,
        },
      },
    })
  ),
  on(getBillingPaymentInfoFailure, (state, { billingAccountNumber }) => ({
    ...state,
    byAccountNumber: {
      ...state.byAccountNumber,
      [billingAccountNumber]: {
        result: null,
        hasError: true,
        isFetching: false,
      },
    },
  }))
);
